<template lang="pug"></template>

<script>
export default {
    name: 'BotaoContratoRastreabilidadeAprovador',
    componentOptions: {
        title: 'Contrato Rastreabilidade Comprador',
        actions: [
            [
                {
                    name: 'Contrato Rastreabilidade Comprador',
                    iconClass: 'lyra-icon lyra-contrato-rastreabilidade',
                    showView: false,
                    action: 'ContratoRastreabilidadeComprador',
                    route: 'contrato-rastreabilidade-comprador'
                }
            ]
        ]
    },

    methods: {
        abrirContratoRastreabilidade() {
            if (this.$route.name !== 'contrato-rastreabilidade-comprador') {
                this.$router.push({ name: 'contrato-rastreabilidade-comprador' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
